import { userManagementService } from '../request'



/**
 * 获取用户列表
 * @param {Object} params 查询参数 {page, size, deptId?, keyword?}
 * @returns {Promise} 返回Promise对象
 */
export const getUserList = (params) => {
  return userManagementService.get('/users', { params })
}

/**
 * 创建用户
 * @param {Object} data 用户数据
 * @returns {Promise} 返回Promise对象
 */
export const createUser = (data) => {
  return userManagementService.post('/users', data)
}

/**
 * 更新用户信息
 * @param {String} id 用户ID
 * @param {Object} data 更新数据
 * @returns {Promise} 返回Promise对象
 */
export const updateUser = (id, data) => {
  return userManagementService.put(`/users/${id}`, data)
}

/**
 * 删除用户
 * @param {String|Array} ids 用户ID或ID数组
 * @returns {Promise} 返回Promise对象
 */
export const deleteUser = (ids) => {
  if (Array.isArray(ids)) {
    return userManagementService.delete('/users', { data: { ids } })
  }
  return userManagementService.delete(`/users/${ids}`)
}

/**
 * 通知用户使用
 * @param {Object} data 用户数据
 * @returns {Promise} 返回Promise对象
 */
export const sendInitPwdBySMS = (data) => {
  return userManagementService.post('/users/send-initial-password', data)
}


// 获取用户待办数量
export function getUserTodoCount() {
  return userManagementService.get('/users/todo-count')
}
